<template>
  <div>
    Renégociation de prêt
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'RenegociationPret'
}
</script>
